import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=592225bc&"
import script from "./DataCell.vue?vue&type=script&lang=js&"
export * from "./DataCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports